import React, {useEffect} from 'react';
import CustomButton from './Components/CustomButton';
import HeroImg from './img/about-frame.png';
import MeImg from './img/me1.png';
import InfoBox from './Components/InfoBox';
import LinkdinLogo from './img/linkdn.png';
import Laptop from './img/laptop.svg';
import QaulityImg from './img/quality.png';
import SupportImg from './img/support.png';
import AccountabilityImg from './img/accountability.png';
import AboutSplitter from './img/about-splitter.png';
import Aos from 'aos';
import "aos/dist/aos.css";

function About() {
   
    useEffect(() => {
        Aos.init({ duration: 700,
            delay:200});
    }, [])

    return (
        <div className="about">
            <div className="about-hero-bg"/>
            <div className="about-hero-content">
                <h1 data-aos="fade-up">ALSIP</h1>
                <img src={HeroImg} style={{maxWidth:"100vw"}}/>
            </div>

                <div className="about-info" >
                    <div className="about-info-bg"/>
                        <div className="about-info-content" data-aos="fade-up">
                        <img src={MeImg} id="meimg"/>
                        <div className="about-info-text">
                            <h5>CHANGING THE SCENE</h5>
                            <p>Launched in 2019 by founder CEO Jake McGee, our mission has been to deliver custom solutions at affordable prices. We work with you to design a beautiful online presence, developed using modern frameworks and technology to keep you ahead of the competition. </p>
                            <a href="https://www.linkedin.com/in/jake-mcgee-3419311ab/"> <img src={LinkdinLogo} style={{width:'2rem'}}/> </a>
                        </div>
                    </div>
                </div>
           <div className="about-info-boxes">
                <InfoBox className="left" 
                    title="QUALITY" 
                    img={QaulityImg}
                    text="Producing quality software is everything we stand for. Our brand and reputation has been built on years of creating quality solutions and it's something we intend to maintain. "/>

                <InfoBox className="right" 
                    title="SUPPORT" 
                    img={SupportImg}
                    text="All of our solution packages come with 1 years worth of support incase you need any assistence. We are very much passionate about our customers and service so we are here to provide support 24/7."
                    link="/websitedevelopment"/>

                
                <InfoBox className="left" 
                    title="ACCOUNTABILITY" 
                    img={AccountabilityImg}
                    text="Every solution we develop is apart of us and our brand. This is why our solution packages come with various benifits to give you assurance that we will deliver on our promises."
                    link="/websitedevelopment"/>
                </div>

                <div className="about-job-splitter">
                   
                    <img src={AboutSplitter}/>

                    <div className="about-job-splitter-content">
                        <h2>START YOUR CAREER WITH ALSIP?</h2>
                        <div className="about-job-splitter-content-btn">
                            <CustomButton text="COMMING SOON.." style={{backgroundColor:'#E92323'}}/>
                        </div>
                    </div>
                </div>     
        </div>
    )
}

export default About
